import React from 'react';
import Highcharts from 'highcharts';

class QrCodeLineChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    const { data, title } = this.props;

    const categories = data.map(d => d[0]);
    const values = data.map(d => d[1]);

    Highcharts.chart(this.chartRef.current, {
      chart: { type: 'line' },
      title: { text: title || 'Scans Over Time' },
      credits: { enabled: false },
      xAxis: {
        categories: categories,
        labels: {
          step: Math.max(1, Math.floor(categories.length / 10)),
          rotation: -45
        }
      },
      yAxis: {
        title: { text: 'Scans' },
        allowDecimals: false
      },
      series: [{
        name: 'Scans',
        data: values,
        color: '#008CBA'
      }],
      legend: { enabled: false },
      tooltip: {
        headerFormat: '<b>{point.key}</b><br/>',
        pointFormat: '{point.y} scans'
      }
    });
  }

  render() {
    return <div ref={this.chartRef} style={{ width: '100%', minHeight: '350px' }} />;
  }
}

export default QrCodeLineChart;
